import { WINDOWS_APP_SOURCE } from '#pplx/frontend/components/utils/consts.js';
import { COMPUTERAPP_SOURCE, LINUX_COMPUTERAPP_SOURCE, WINDOWS_COMPUTERAPP_SOURCE, XPLAT_MACOS_COMPUTERAPP_SOURCE, } from '#pplx/frontend/fetcher/constants.js';
export const getAnalyticsQuerySource = (isWindowsApp, bootstrapConfigErp, isLinuxOS = false, isMacOS = false) => {
    if (import.meta.env.VITE_IS_COMPUTER_APP_BUILD) {
        return COMPUTERAPP_SOURCE;
    }
    if (import.meta.env.VITE_IS_PERPLEXITY_DESKTOP_BUILD) {
        if (isMacOS)
            return XPLAT_MACOS_COMPUTERAPP_SOURCE;
        return isLinuxOS ? LINUX_COMPUTERAPP_SOURCE : WINDOWS_COMPUTERAPP_SOURCE;
    }
    if (isWindowsApp) {
        return WINDOWS_APP_SOURCE;
    }
    return bootstrapConfigErp ?? undefined;
};
//# sourceMappingURL=getAnalyticsQuerySource.js.map